import React, { useState, useEffect } from "react";
import $ from "jquery";
import Google from "./Google";
import { useDispatch, useSelector } from "react-redux";
import { setStoreData, getProductPrice } from "../store/auth";
import { API } from "aws-amplify";
import { Link, useNavigate } from "react-router-dom";

export default function Apps() {
  const [accountType, setAccountType] = useState("free");
  const [plans, setPlans] = useState({
    subscriptions: [],
    invoices: [],
    billings: {},
  });
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, user, plan } = useSelector(
    (state) => state.auth.data || {}
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getPlanFromProps = function () {
    const session = user.getSignInUserSession();

    const myInit2 = {
      queryStringParameters: {
        action: "plan",
      },
      headers: {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      },
    };

    if (plan === null) {
      API.get("HandLAPI", "/myaccount", myInit2)
        .then((response) => {
          console.log(response);
          setPlans(response);

          if (response.subscriptions.length > 0) {
            dispatch(
              setStoreData({ data: { plan: response, AppEligible: false } })
            );

            response.subscriptions.forEach((element) => {
              setStateForElement(element);
            });
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } else {
      //local cache
      setPlans(plan);
      setLoading(false);
      plan.subscriptions.forEach((element) => {
        setStateForElement(element);
      });
    }
  };

  const setStateForElement = function (element) {
    setAccountType(getAccountStatus(element));

    if (
      (element["plan_name"] == "Starter+" ||
        element["plan_name"] == "Premium") &&
      (element["subscription_status"].toLowerCase() === "active" || element["subscription_status"].toLowerCase() === "expiring")
    ) {
      dispatch(setStoreData({ data: { AppEligible: true } }));
    }
  };

  var getAccountStatus = function (element) {
    var account_status = "paid";
    if (
      element["subscription_status"].toLowerCase() === "canceled" ||
      element["subscription_status"].toLowerCase() === "cancelled"
    ) {
      account_status = "free";
    }
    return account_status;
  };
  useEffect(() => {
    if (isAuthenticated && user) {
      getPlanFromProps();
    } else {
      navigate("/");
    }

    // $.magnificPopup.open(
    //   {
    //     items: {
    //       src: '#apps',
    //     },
    //     type: 'inline',
    //     closeOnBgClick: false,
    //     enableEscapeKey: false,
    //     // showCloseBtn:false,
    //     callbacks: {
    //       close: () => setMainStates('showApps', false),
    //     },
    //   },
    //   0
    // );
  }, []);

  const onUpgrade = (event) => {
    event.preventDefault();
    // $.magnificPopup.close();
    // setMainStates('flowSelected', 'paid');
    // setMainStates('showPayment', true);
    // setMainStates('selected_plan', 'starter', () => getProductPrice(''));
  };
  return (
    <div id="apps" className="container m-auto">
      <div className="p-2 text-center">
        {loading && (
          <div>
            <div className="fa-3x">
              <i className="fa fa-spinner fa-spin"></i>
            </div>
            <p>Please wait...</p>
          </div>
        )}
        {!loading && accountType == "free" && (
          <div className="row">
            <div className="text-center m-t-40">
              <h3 className="text-2xl font-medium">
                Please upgrade to access the HandL Apps for FREE.
              </h3>
              <h4 className="text-xl mt-2">
                Click below to get many more features and premium customer
                support
              </h4>
              {/* <a className='btn btn-primary btn-md py-2 mt-5' onClick={onUpgrade}>
                Upgrade Now
              </a> */}
              <Link
                to="/#prices"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 mt-5 focus:outline-none inline-block hover:text-white"
              >
                Upgrade Now
              </Link>
            </div>
          </div>
        )}
        {!loading && accountType === "paid" && <Google />}
      </div>
    </div>
  );
}
